import { useState } from 'react';

type ReturnType = {
  formPreviewModal: {
    isOpen: boolean;
    close: () => void;
    open: () => void;
  };
};

export function useCustomFormEditorModalsState(): ReturnType {
  const [isFormPreviewModalOpen, setIsFormPreviewModalOpen] = useState(false);

  return {
    formPreviewModal: {
      isOpen: isFormPreviewModalOpen,
      close: () => setIsFormPreviewModalOpen(false),
      open: () => setIsFormPreviewModalOpen(true),
    },
  };
}
